import styled from "@emotion/styled";
import { Paper, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import {
  COLOR_BLACK,
  COLOR_GREY_2,
  COLOR_GREY_9,
  COLOR_PRIMARY_MAIN,
} from "shared/theme/colors";

export const StyledDataGrid = styled(DataGrid)`
  border: none;
  cursor: pointer;

  & .MuiDataGrid-columnHeaderTitle {
    color: ${COLOR_BLACK};
    font-weight: 700;
  }

  & .MuiDataGrid-columnSeparator {
    display: none;
  }

  & .MuiDataGrid-iconButtonContainer {
    margin-left: 0.25rem;
  }

  .MuiDataGrid-virtualScroller {
    min-height: 120px;
  }

  & .MuiDataGrid-columnHeader,
  .MuiDataGrid-cell {
    padding: 0.5rem;
    white-space: normal;
    outline: none;

    &:focus,
    &:focus-within {
      outline: none;
    }
  }

  & .MuiDataGrid-footerContainer {
    display: none;
  }
`;

export const StyledSpinnerWrapper = styled(FlexCenter)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledHint = styled(Typography)`
  font-size: 14px;
  color: ${COLOR_PRIMARY_MAIN};
`;

export const StyledEmptyWrapper = styled(FlexCenter)`
  margin-top: 1rem;
  background-color: ${COLOR_GREY_2};
  height: 80px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 1rem;
`;

export const StyledPaper = styled(Paper)`
  box-shadow: none;
`;

export const StyledTypography = styled(Typography)`
  color: ${COLOR_GREY_9};
  font-size: 0.875rem;
  line-height: 1.875rem;
`;
